module.exports = __webpack_public_path__ + "media/assets/images/blog/DALL·E_omnichannel_in_customer_service-small-27222b8d7a6d2e2ef30ca8b6a021bc91.png";